import { IItem } from "./IItem";

export interface IEmptyValidatable extends IItem {
  name: string;
  enableSingleEmptyCheck: boolean;
  alertGroupKey: string;
  isEmpty: boolean; /* チェック・円選択は単体で空かどうかを見ても判定できないので注意すること */
  enableEmptyCheckConfirmation: boolean;
}

export function instanceOfIEmptyValidatable(instance: any): instance is IEmptyValidatable {
  return instance
    && (instance.isEmpty !== undefined);
}
